import ko from './ko.js';
import en from './en.js';
import ja from './ja.js';
import zh from './zh.js';
import es from './es.js';
import de from './de.js';
import fr from './fr.js';
import pt from './pt.js';
import th from './th.js';

type Translations = Record<string, string>;
const LANGS: Record<string, Translations> = { ko, en, ja, zh, es, de, fr, pt, th };

let currentLang = 'ko';

export function initI18n(lang?: string) {
  currentLang = lang || detectLanguage();
}

function detectLanguage(): string {
  const nav = typeof navigator !== 'undefined' ? navigator.language.split('-')[0] : 'ko';
  return LANGS[nav] ? nav : 'en';
}

export function t(key: string): string {
  return (LANGS[currentLang] as any)?.[key] ?? (LANGS['en'] as any)?.[key] ?? key;
}

export function setLanguage(lang: string) {
  if (LANGS[lang]) currentLang = lang;
}

export function getCurrentLanguage(): string {
  return currentLang;
}

export function getAvailableLanguages(): string[] {
  return Object.keys(LANGS);
}
